module.exports = "/_next/static/images/431c53c258d5b7f3c6b4fb2b5485a82d-YourMoneyIsGrowing.png.webp";